export default "__VITE_ASSET__DHX0OU7S__"